import { render, staticRenderFns } from "./TheCategoryHamburger.vue?vue&type=template&id=00387b54"
import script from "./TheCategoryHamburger.vue?vue&type=script&lang=js"
export * from "./TheCategoryHamburger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports